// extracted by mini-css-extract-plugin
export default {"wrapper":"WC-z","viewport":"XC-z","container":"YC-z","slide":"ZC-z"};